import { CurrencyToken, CurrencyTokenType } from '@apeiron/currency'
import { deserializeData, MayNull } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { obitalTrackSuggestCurrencySchema } from '@src/deserialize/yup/orbitalTrack'
import grapql from '@src/graphql/query/getOrbitalTrackSuggestFee'
import { useCallback, useState } from 'react'

const useGetOrbitalTrackSuggestFee = (): Hook => {
  const [fetchSuggestFee] = useLazyQuery(grapql)

  const [data, setData] = useState<MayNull<CurrencyToken>>(null)

  const fetch = useCallback(
    async (request: Request): Promise<Response> => {
      const { agingBuff, currency } = request

      const response = await fetchSuggestFee({
        variables: { agingBuff, currency }
      })

      const price = deserializeData<CurrencyToken>(
        response,
        obitalTrackSuggestCurrencySchema
      )

      setData(price)

      return price
    },
    [fetchSuggestFee]
  )

  return {
    data,
    fetch
  }
}

type Request = {
  agingBuff: number
  currency: CurrencyTokenType
}

type Response = MayNull<CurrencyToken>

type Hook = {
  data: Response
  fetch: (request: Request) => Promise<Response>
}

export default useGetOrbitalTrackSuggestFee
